/* ============================================================
   DATA KONTAK RESMI RS JMC

   Berkas ini adalah SUMBER TUNGGAL untuk nomor, email, dan akun sosial.
   Header.jsx sudah mengimpornya:

     import { CONTACT, SOCIALS } from "../data/contact";

   ⚠️ CARA MEMAKAI BERKAS INI KALAU KAMU SUDAH PUNYA contact.js
   Saya belum pernah melihat isi berkas aslimu, jadi JANGAN langsung
   menimpanya. Buka punyamu lebih dulu:

     - Kalau di dalamnya hanya ada CONTACT dan SOCIALS, timpa saja.
     - Kalau ada ekspor lain (misalnya JAM_OPERASIONAL, ALAMAT, atau
       apa pun yang diimpor komponen lain), SALIN hanya dua konstanta
       di bawah ini ke berkasmu. Menimpa berkasnya akan menghapus
       ekspor lain itu dan membuat komponen yang mengimpornya gagal
       build dengan pesan "X is not exported from ...".

   ============================================================
   BENTUK DATANYA MENGIKUTI APA YANG SUDAH DIPAKAI Header.jsx

   CONTACT.phoneHref   -> href tautan telepon
   CONTACT.phoneLabel  -> yang tampil di layar
   CONTACT.emailHref   -> href mailto
   CONTACT.email       -> yang tampil di layar

   Nomor dan tampilannya sengaja dipisah karena keduanya butuh format
   berbeda: mata membaca "(021) 798 0888", aplikasi telepon butuh
   "+62217980888" tanpa spasi maupun tanda kurung.
   ============================================================ */

export const CONTACT = {
  phoneLabel: "(021) 798 0888",
  phoneHref: "tel:+62217980888",
  email: "rsjmcid@rsjmc.id",
  emailHref: "mailto:rsjmcid@rsjmc.id",
};

/* ============================================================
   AKUN SOSIAL

   `handle` = teks yang tampil di utility bar header. Inilah yang
   sebelumnya masih tertulis "@username".
   `href`   = alamat profilnya, diambil dari Footer.jsx.
   `nama`   = label manusiawi, dipakai untuk aria-label.

   ⚠️ HANYA INSTAGRAM DAN X YANG AKAN MUNCUL DI HEADER, dan itu bukan
   kebetulan. Header punya peta ikon bernama SOCIAL_ICONS yang saat ini
   hanya memuat `instagram` dan `x`; entri yang key-nya tidak ada di
   peta itu dilewati diam-diam oleh baris `if (!Icon) return null`.

   Jadi kalau kamu ingin Facebook, YouTube, atau LinkedIn ikut tampil di
   header, tidak cukup menghapus komentarnya di sini - kamu juga harus
   menambahkan ikonnya ke SOCIAL_ICONS di Header.jsx. Perilaku "gagal
   diam-diam" itu memang bukan rancangan yang ideal, tapi ia sudah ada
   di kodenya dan saya biarkan supaya tidak mengubah hal yang tidak kamu
   minta.

   Saya sarankan tetap dua saja. Utility bar itu tinggi 40px dan sudah
   berisi "Hubungi Kami", nomor telepon, dan email; lima handle lagi
   akan memadatkannya sampai sulit dibaca. Kelima akun sudah lengkap
   tersedia di footer, tempat yang memang orang tuju untuk itu.

   Tiga akun di bawah tetap ditulis - bukan sebagai hiasan, tapi supaya
   berkas ini bisa jadi sumber tunggal saat nanti Footer.jsx ikut
   mengimpor dari sini dan berhenti menyimpan URL-nya sendiri. */
export const SOCIALS = [
  {
    key: "instagram",
    nama: "Instagram",
    handle: "@jmchospital",
    href: "https://www.instagram.com/jmchospital",
  },
  {
    key: "x",
    handle: "@JMCHospital",
    href: "https://x.com/JMCHospital",
  },

  /* Belum tampil di header sampai ikonnya ditambahkan ke SOCIAL_ICONS. */
  {
    key: "facebook",
    nama: "Facebook",
    handle: "Facebook",
    /* ⚠️ Masih tautan pendek /share/. Sebaiknya diganti alamat halaman
       aslinya - buka di desktop, lalu salin dari bilah alamat. */
    href: "https://www.facebook.com/share/1ESz8VVyMf/",
  },
  {
    key: "youtube",
    nama: "YouTube",
    handle: "@rumahsakitjakartamedicalce2343",
    href: "https://www.youtube.com/@rumahsakitjakartamedicalce2343",
  },
  {
    key: "linkedin",
    nama: "LinkedIn",
    handle: "jmchospital",
    href: "https://www.linkedin.com/company/jmchospital/",
  },
];
